import { UserAvatarBanner } from "./UserAvatarBanner.jsx";
import { UserInfoCard } from "./UserInfoCard.jsx";
import { UserPermissionsSection } from "./UserPermissionsSection.jsx";

export function UserProfilePanel({
  user,
  permissions,
  permsLoading,
  onRemovePermission,
  addPermOpen,
  addablePermissions,
  onAddPermission,
  onCloseAdd,
  c,
  dark,
  A,
}) {
  if (!user) {
    return (
      <div style={{ textAlign: "center", padding: "48px 24px", color: c.sub, fontSize: 14 }}>
        Select a user to view details
      </div>
    );
  }

  return (
    <>
      <UserAvatarBanner user={user} c={c} dark={dark} A={A} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <UserInfoCard label="Email" value={user.email} c={c} dark={dark} />
        <UserInfoCard label="Name" value={user.name} c={c} dark={dark} />
      </div>
      <UserPermissionsSection
        permissions={permissions}
        permsLoading={permsLoading}
        onRemove={onRemovePermission}
        addPermOpen={addPermOpen}
        addablePermissions={addablePermissions}
        onAdd={onAddPermission}
        onCloseAdd={onCloseAdd}
        c={c}
        dark={dark}
      />
    </>
  );
}
